<template>
	<div class="wrap">
		<div class="row">
			<div class="label">Дата записи</div>
			<DatePicker v-model="date" type="date" format="DD.MM.YYYY" />
		</div>

		<div class="row">
			<div class="label">Время записи</div>
			<VueTimepicker v-model="time" :minute-interval="5" close-on-complete />
		</div>

		<div class="row">
			<uiDropdown
				:options="titleOptions"
				label="Название"
				:clearSearchOnSelect="true"
				:value="title"
				@input="title = $event"
			/>
		</div>

		<div class="row">
			<uiInput
				v-model="clinic"
				label="Клиника"
				style="margin: 5px 0"
				placeholder="Например, Ветсити"
			/>
		</div>

		<div class="row">
			<uiInput
				v-model="medic"
				label="Врач"
				style="margin: 5px 0"
				placeholder="Фамилия И.О."
			/>
		</div>

		<div class="row">
			<uiDropdown
				:options="iconOptions"
				label="Иконка"
				:clearSearchOnSelect="true"
				:value="selectedIcon"
				@input="selectedIcon = $event"
			/>
		</div>

		<div class="label">Как будет выглядеть:</div>
		<PetEvent :event="event" />

		<uiButton style="margin: 10px 0" @click="save" :disabled="!valid">
			Сохранить
		</uiButton>
		<uiButton color="light" v-if="initial" @click="remove">Удалить</uiButton>
	</div>
</template>

<script>
import { format } from 'date-fns'
import PetEvent from '@/components/PetEvent'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

export default {
	name: 'PetEventCreate',
	components: {
		PetEvent,
		VueTimepicker,
		DatePicker,
	},
	props: {
		initial: Object,
	},
	data() {
		return {
			id: 'new',
			title: '',
			clinic: '',
			time: '',
			medic: '',
			date: Date.now(),

			selectedIcon: { value: '👩‍⚕️', label: 'Врач (девушка)' },
			titleOptions: [
				'Приём терапевта',
				'Приём гастроэнтеролога',
				'Приём кардиолога',
				'Приём невролога',
				'Приём онколога',
				'Приём офтальмолога',
				'Приём хирурга',
				'УЗИ',
				'КТ',
				'МРТ',
				'Анализы',
				'Чекап',
			],
			iconOptions: [
				{ value: '👩‍⚕️', label: 'Врач (девушка)' },
				{ value: '👨‍⚕️', label: 'Врач (парень)' },
				{ value: '🥩', label: 'Доставка еды' },
				{ value: '💅', label: 'Когтитюр' },
				{ value: '🐶', label: 'Собачка' },
				{ value: '🐱', label: 'Кошечка' },
				{ value: '❤️', label: 'Сердечко' },
			],
		}
	},
	computed: {
		event() {
			let kind = 'appointment'
			if (this.initial && this.initial.kind) kind = this.initial.kind
			let details = this.initial?.details
			return {
				kind: kind,
				title: this.title,
				text: this.text,
				icon: this.icon,
				date: this.date,
				details: details,
			}
		},
		icon() {
			return this.selectedIcon.value
		},
		text() {
			return [this.time, this.clinic, this.medic].filter((i) => i).join(', ')
		},
		valid() {
			if (this.event.kind === 'dogologyDelivery') return true
			return this.title && this.time && this.date
		},
	},
	watch: {
		initial(nv) {
			if (nv) this.setupInitial()
			else this.clear()
		},
	},
	created() {
		this.setupInitial()
	},
	methods: {
		setupInitial() {
			if (!this.initial) return
			let ev = this.initial
			this.id = ev.id
			this.title = ev.title
			this.date = new Date(ev.date)

			if (ev.text) {
				let parts = ev.text.split(', ')
				if (parts[0]) this.time = parts[0]
				if (parts[1]) this.clinic = parts[1]
				if (parts[2]) this.medic = parts[2]
			}

			if (this.event.kind === 'dogologyDelivery') {
				this.selectedIcon = { value: '🥩', label: 'Доставка еды' }
			} else {
				let icon = this.iconOptions.find((o) => o.value === ev.icon)
				this.selectedIcon = icon
			}
		},
		clear() {
			this.id = 'new'
			this.title = ''
			this.clinic = ''
			this.time = ''
			this.medic = ''
			this.date = Date.now()
			this.selectedIcon = { value: '👩‍⚕️', label: 'Врач (девушка)' }
		},
		save() {
			let payload = { ...this.event }
			payload.id = this.id
			this.$emit('save', payload)
		},
		remove() {
			this.$emit('remove', { id: this.id })
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.wrap {
	background: #fff;
	padding: 16px;
	border-radius: 20px;
	box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.2);
}

.row {
	margin-bottom: 10px;
}

.label {
	font-size: 14px;
	opacity: 0.5;
	margin-bottom: 3px;
}

.time-wrap {
	display: flex;
}
</style>
